<template>
  <div v-loading="loading" class="admin">
    <h2>Criar Categoria</h2>
    <el-form ref="form" :model="book" label-width="120px">
      <el-row :gutter="20">
        <el-col :lg="8" :offset="8">
          <el-form-item label="Categoria">
            <el-input v-model="tag.value"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :lg="8" :offset="8">
          <el-form-item style="float: right">
            <el-button type="primary" @click="createTag">Criar</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { createTag } from "../../../services/tags";
export default {
  data() {
    return {
      tag: {},
    };
  },

  methods: {
    async createTag() {
      const response = await createTag(this.tag);
      if (response.status === 201) {
        this.$message.success("Categoria criada com sucesso!");
        this.$router.push(`/admin/tags`);
      }
    },
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.inputSelection {
  text-align: center;
}

.admin {
  margin: 30px;
}
</style>
